import Pagination from "react-js-pagination";
import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment";
import { open, close } from "../redux/popupSlice";

import routes from '../libs/routes';
import images from "../libs/images";
import * as API from "../libs/service";

import Popup01 from "../pages/popup/Popup01"
import PopupPlusMember from "../pages/popup/PopupPlusMember"
import { setTeams } from "../redux/teamSlice";

export default function PaginationGroupList(props) {
    const {
        coupon,
        setSelectedItems,
        modifyLicense,
        chkReset
    } = props

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const dataList = useSelector((state) => state.teamReducer.teams);

    const { mbData } = useSelector((s) => s.usersReducer);
    const lang = useSelector(state => state.langReducer.lang);

    /*
    const orgId = 1; // 예시
const orgDetail = await API.get(`organization/${orgId}`);
const newOrg = await API.post('organization', { name: '개발1팀' });
console.log(newOrg.data);
const orgId = 1;
const updated = await API.patch(`organization/${orgId}`, { name: '새이름' });
const orgId = 1;
await API.delete(`organization/${orgId}`);


const teamId = 10;
const teamDetail = await API.get(`team/${teamId}`);
console.log(teamDetail.data);
// 클라이언트
const orgId = 1;
const newTeam = await API.post(`team/${orgId}`, { name: '개발1팀' });
console.log(newTeam.data);

// 클라이언트
const teamId = 10;
const updatedTeam = await API.patch(`team/${teamId}`, { name: '새 팀 이름' });
console.log(updatedTeam.data);
// 클라이언트
const teamId = 10;
await API.delete(`team/${teamId}`);
console.log('팀 삭제 완료');

// 클라이언트
const teamId = 10;
const userId = 5;
const updatedTeam = await API.post(`team/${teamId}/member/${userId}`);
console.log(updatedTeam.data);

// 클라이언트
const teamId = 10;
const userId = 5;
await API.delete(`team/${teamId}/member/${userId}`);
console.log('멤버 삭제 완료');

// 클라이언트
const fromTeamId = 10;
const toTeamId = 12;
const userId = 5;
const result = await API.post(`team/move/${fromTeamId}/${toTeamId}/${userId}`);
console.log(result.data);

    */

    const getTeamList = async () => {
        const teamList = await API.get(`team/user/${mbData.idx}`, {}, true);
        console.log("teamList : ", teamList);
        dispatch(setTeams(teamList.data));
    }

    useEffect(() => {
        if (mbData?.idx) {
            getTeamList();
        }
    }, [mbData]);

    const popupOpen = useSelector((state) => state.popupReducer.open);

    useEffect(() => {
        if (!popupOpen) {
            getTeamList();
        }
    }, [popupOpen]);

    // const [checkboxStates, setCheckboxStates] = useState(new Array(dataList.length).fill(false));
    const [isAllChecked, setIsAllChecked] = useState(false);

    const [page, setPage] = useState(1);
    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    useEffect(() => {
        setIsAllChecked(false);
        // setCheckboxStates(new Array(dataList.length).fill(false))
        setSelectedItems([])
    }, [chkReset]);

    const itemsPerPage = 8;
    const indexOfLastItem = page * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    console.log("dataList : ", dataList);
    const Items = dataList ? dataList.slice(indexOfFirstItem, indexOfLastItem) : [];

    const group_name_sample = ['개발 1팀', '개발 2팀', '개발 3팀', '개발 4팀', '개발 5팀', '개발 6팀', '개발 7팀', '개발 8팀', '개발 9팀', '개발 10팀']

    const MeberSetFunc = () => {
        dispatch(open({
            component:
                <PopupPlusMember
                    max_width={'400px'}
                    button={lang === 0 ? '확인' : 'OK'}
                    buttonCancel={'취소'}
                    member_set={true}
                />
        }));
    }

    /* console.log("Current Page:", page);
    console.log("indexOfFirstItem:", indexOfFirstItem, "indexOfLastItem:", indexOfLastItem);
    console.log("Items:", Items); */

    console.log("dataList : ", dataList);
    console.log("Items ?: ", Items);
    return (
        <div className="PaginationContent">
            <div className="plus_group_box">
                {dataList && dataList.length > 0 ?
                    <>
                        {Items.map((x, i) => (
                            <div key={x} className={`plus_group_bar`}>
                                <p className="group_title">{x.name}</p>

                                <div className="setting_box">
                                    <div className="text">
                                        <p>{lang === 0 ? '멤버' : 'Member'}</p>
                                        <span>{x.users?.length || 0}</span>
                                    </div>

                                    <button
                                        type="button"
                                        onClick={() => {
                                            navigate(routes.PlusMember, {
                                                state: {
                                                    teamId: x.id
                                                }
                                            });
                                        }}
                                    >
                                        {lang === 0 ? '관리' : 'Manage'}
                                    </button>
                                </div>
                            </div>
                        ))}

                        {/* <div className={`my_coupon_info`}>
                            <p>aiffasf@naver.com</p>
                            <p>이름입니다</p>
                            <p className="license_off">
                                비활성
                            </p>
                            <p className="member_set">
                                <span
                                    onClick={() => {
                                        MeberSetFunc()
                                    }}
                                >
                                    관리
                                </span>
                            </p>
                        </div> */}
                    </>
                    :
                    <p className="not_coupon">조직이 없습니다.</p>
                }

            </div>

            <Pagination
                className="my-pagination"
                // 현재 보고있는 페이지
                activePage={page}
                // 한페이지에 출력할 아이템수
                itemsCountPerPage={8}
                // 총 아이템수
                totalItemsCount={dataList?.length || 1}
                // 표시할 페이지수
                pageRangeDisplayed={10}
                // 함수
                onChange={handlePageChange}
                nextPageText={<img src={require("../assets/icon/page_right.svg").default} />}
                prevPageText={<img src={require("../assets/icon/page_left.svg").default} />}
                firstPageText={<img src={require("../assets/icon/page_left_set.svg").default} />}
                lastPageText={<img src={require("../assets/icon/page_right_set.svg").default} />}
            ></Pagination>
        </div>
    )
}